import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonRow,
  IonCol,
  IonItem,
  IonLabel,
  IonInput,
  IonButton,
} from '@ionic/react';
import React, { useState, useEffect } from 'react';
import 'react-quill/dist/quill.snow.css';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { updateProfile, getProfile } from '../actions/profile';

const EditProfile = ({ profile: { profile, loading }, getProfile, updateProfile, history }) => {
  const [name, setName] = useState('');
  const [bio, setBio] = useState('');
  const [avatar, setAvatar] = useState('');

  useEffect(() => {
    getProfile();
    setName(loading || !profile.name ? '' : profile.name);
    setBio(loading || !profile.bio ? '' : profile.bio);
    setAvatar(loading || !profile.avatar ? '' : profile.avatar);
    // eslint-disable-next-line
  }, [loading]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const editData = {
      name: name,
      bio: bio,
      avatar: avatar,
    };
    updateProfile(editData, history);
    history.push('/profile');
  };

  return (
    <IonContent>
      <IonHeader>
        <IonToolbar color='secondary'>
          <IonTitle>
            <h5 className='title'>Edit Profile</h5>
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonRow className='ion-justify-content-center' style={{ marginTop: '10%' }}>
        <IonCol sizeLg='8' sizeMd='auto'>
          <IonItem>
            <IonLabel position='floating'> Name</IonLabel>
            <IonInput
              type='Name'
              value={name}
              onIonChange={(e) => setName(e.detail.value)}
              style={{ marginTop: '5px' }}
            ></IonInput>
          </IonItem>
        </IonCol>
      </IonRow>

      <IonRow className='ion-justify-content-center'>
        <IonCol sizeLg='8' sizeMd='auto'>
          <IonItem>
            <IonLabel position='floating'> Biography</IonLabel>
            <IonInput
              type='Biography'
              value={bio}
              onIonChange={(e) => setBio(e.detail.value)}
              style={{ marginTop: '5px' }}
            ></IonInput>
          </IonItem>
        </IonCol>
      </IonRow>
      <IonRow className='ion-justify-content-center'>
        <IonCol sizeLg='8' sizeMd='auto'>
          <IonItem>
            <IonLabel position='floating'> Avatar</IonLabel>
            <IonInput
              type='Avatar'
              value={avatar}
              onIonChange={(e) => setAvatar(e.detail.value)}
              style={{ marginTop: '5px' }}
            ></IonInput>
          </IonItem>
        </IonCol>
      </IonRow>

      <IonRow className='ion-justify-content-center'>
        <IonCol sizeLg='3' sizeMd='auto'>
          <IonButton expand='block' style={{ marginTop: '32px' }} onClick={(e) => handleSubmit(e)}>
            SUBMIT
          </IonButton>
        </IonCol>
      </IonRow>
    </IonContent>
  );
};

EditProfile.propType = {
  getProfile: PropTypes.func.isRequired,
  updateProfile: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps, { getProfile, updateProfile })(withRouter(EditProfile));
